/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waiting_On_Customer_ServiceInputs */

const en_waiting_on_customer_service = /** @type {(inputs: Waiting_On_Customer_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting on the Customer Service`)
};

/**
* | output |
* | --- |
* | "Waiting on the Customer Service" |
*
* @param {Waiting_On_Customer_ServiceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const waiting_on_customer_service = /** @type {((inputs?: Waiting_On_Customer_ServiceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waiting_On_Customer_ServiceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_waiting_on_customer_service(inputs)
});